import React, { useContext } from "react";
import UptimeGrid from "../../layoutComponents/Grid";
import UptimeRow from "../../layoutComponents/Row";
import UptimeBox from "../../layoutComponents/Box";
import { StyledTypography, StyledCol } from "./genericAllCategories.style";
import HyperLink from "../../commonComponents/hyperLink/hyperLink";
import { ThemeContext } from "styled-components";

export interface IGenericAllCategoriesProps {
  data?: any;
}

const GenericAllCategories = (props: IGenericAllCategoriesProps) => {
  const { data } = props;
  const theme = useContext(ThemeContext);

  return (
    <UptimeGrid mb="80px" mt={`${theme.uptimeSpace[20]}px`}>
      <UptimeRow>
        {data &&
          data?.listCategory?.map((items: any) => (
            <StyledCol
              colspan={{ xs: "12", sm: "6", md: "4", lg: "3", xl: "3" }}
            >
                {items.icon && (
                  <UptimeBox mb={`${theme.uptimeSpace[12]}px`} height="40px">
                    {items.icon}
                  </UptimeBox>
                )}
                <StyledTypography
                  kind="h5"
                  fontWeight={600}
                  fontSize={`${theme.uptimeFontSizes.desktop.fz7}px`}
                >
                  {items.category}
                </StyledTypography>
                {items.content ? (
                  <UptimeBox
                    pt={`${theme.uptimeSpace[10]}px`}
                    ml={`${theme.uptimeSpace[4]}px`}
                  >
                    <StyledTypography
                      color={`${theme.uptimeColors.grayScales.gray} !important`}
                    >
                      {items.content}
                    </StyledTypography>
                  </UptimeBox>
                ) : (
                  <UptimeGrid
                    flexDirection="column"
                    justifyContent="space-between"
                  >
                    {items.subCategory.map((item: any) => (
                      <UptimeBox
                        pt={`${theme.uptimeSpace[10]}px`}
                        ml={`${theme.uptimeSpace[4]}px`}
                      >
                        <HyperLink
                          kind="buttonSmall"
                          style={{ textTransform: "capitalize" }}
                          label={item.name}
                          onClick={() => {
                            window.location.href = item.url;
                          }}
                        />
                      </UptimeBox>
                    ))}
                    {items.viewAll.enabled && (
                      <UptimeBox
                        pt={`${theme.uptimeSpace[10]}px`}
                        ml={`${theme.uptimeSpace[4]}px`}
                      >
                        <HyperLink
                          kind="buttonSmall"
                          style={{ textTransform: "capitalize" }}
                          onClick={() => {
                            window.location.href = items.viewAll.url;
                          }}
                          label={
                            items.viewAll.name
                              ? items.viewAll.name
                              : "View All"
                          }
                          showArrow={true}
                        />
                      </UptimeBox>
                    )}
                  </UptimeGrid>
                )}
            </StyledCol>
          ))}
      </UptimeRow>
    </UptimeGrid>
  );
};

export default GenericAllCategories;
